module.exports = __webpack_public_path__ + "static/fonts/OpenSans-Bold.f5331cb.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/font/OpenSans-Bold.ttf
// module id = 7KuX
// module chunks = 3